import { graphql, Link, StaticQuery } from "gatsby"
import Img from "gatsby-image"

import React, { Component } from "react"

import * as landingStyles from "../styles/landing.module.css"

export default class Landing extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query HiQuery {
            file(relativePath: { eq: "hiii.png" }) {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        `}
        render={data => (
          <React.Fragment>
            <div
              className={landingStyles.divider}
              data-sal="slide-up"
              data-sal-delay="300"
              data-sal-easing="ease"
            ></div>
            <div className="container">
              <section className={`row ${landingStyles.mainDiv}`}>
                <div className={landingStyles.imgDiv}>
                  <Img
                    className={landingStyles.landing_image}
                    fluid={data.file.childImageSharp.fluid}
                    alt="Hello There"
                    title="Hello"
                  />
                </div>
                <div className={landingStyles.sideDiv}>
                  {/* <div className={landingStyles.name}>
                    {data.markdownRemark.frontmatter.name}
                  </div> */}
                  <p className={landingStyles.locationText}>
                    {" "}
                    Developer from <b>Mumbai, India.</b>
                  </p>
                  <div className={landingStyles.flip}>
                    <div>
                      <div>Web App Developer</div>
                    </div>
                    <div>
                      <div>Flutter Developer</div>
                    </div>
                    <div>
                      <div>
                        <Link to="/animes">Anime Enthusiast</Link>
                      </div>
                    </div>
                  </div>
                  <p className={landingStyles.locationText}>
                    Battling bugs since 2017.
                  </p>
                </div>
              </section>
            </div>
          </React.Fragment>
        )}
      />
    )
  }
}
